import { lazyLoad } from '@if/core/utils'

export enum ESystemMatchingResult {
  Sure = 'sure',
  Potential = 'potential',
  None = 'none',
  Unprocessed = 'unprocessed',
  Error = 'error',
}

export enum EInteracWireStatus { 
  Unprocessed = "unprocessed",
  Matched = "matched",
  Discarded = "discarded",
  InProcess = "inprocess"
}

export enum EPpaCustomerTypeName {
  Auto = 0,
  Evolupret = 1,
  Other = 2,
  Factoring = 3,
  PersonalLoan = 4,
  AftermarketProducts = 5,
  RSLA = 6,
  ExtendedWarranty = 7,
  RslaCredit = 8,
}

export const getESystemMatchingResultList = lazyLoad(() =>
  Object.values(ESystemMatchingResult).filter((value) => value !== ESystemMatchingResult.Unprocessed),
)

export interface InteracWireFiltersType {
  clientNameContains: string | null
  email: string | null
  systemMatchingResult: ESystemMatchingResult
  isUnmatchedWire: boolean
  limit: number
  offset: number
}

export interface InteracPossibleMatchNote {
  note: string
  createdOn: string // DateTime string
  createdByUsername: string
}

export interface InteracPossibleMatch {
  loanId: string
  referenceNumber: string
  applicantPhoneNumber: string
  applicantFirstName: string
  applicantLastName: string
  applicantEmail: string
  coapplicantPhoneNumber: string | null
  coapplicantFirstName: string | null
  coapplicantLastName: string | null
  coapplicantEmail: string | null
  ppaCustomerTypeName: EPpaCustomerTypeName
  lateAmount: number
  loanBalance: number
  notes: InteracPossibleMatchNote[]
  merchantName: string
}

export interface InteracWire {
  id: string
  message: string | null
  receivedOn: string // DateOnly
  amount: number
  possibleMatches: InteracPossibleMatch[]
  paymentId: string | null
  linkedBy: string | null
  linkedOn: string | null // DateTime string
  linkedProgram: string | null
  linkedLoanId: string | null
  senderEmail: string
  sentBy: string
  searchableSentBy: string
  bankName: string
  systemMatchingResult: string | null
  versionTag: string
  status: EInteracWireStatus
  discardedBy: string | null
  discardedOn: string | null // DateTime string
  discardReason: string | null
  dateOverride: string | null // DateOnly
}

export interface InteracWireHistoryFiltersType {
  status: EInteracWireStatus.Matched | EInteracWireStatus.Discarded
  clientNameContains: string | null
  email: string | null
  limit: number
  offset: number
}
